import React, { useRef, useState } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { db } from '../firebase'; // adjust the path if needed
import { collection, addDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
export default function FullLeaseDocument({onClose}) {
  const [tenantSigned, setTenantSigned] = useState(false);
const [landlordSignedSection8, setLandlordSignedSection8] = useState(false);
const [landlordSignedBottom, setLandlordSignedBottom] = useState(false);const [section8Signed, setSection8Signed] = useState(false);
const [section14Initialed, setSection14Initialed] = useState(false);
const [initial1, setInitial1] = useState(false);
const [loading, setLoading] = useState(false);
const [signed, setSigned] = useState(false);
const [initial2, setInitial2] = useState(false);
const [initial3, setInitial3] = useState(false);
const [legalClauseSignedTenant, setLegalClauseSignedTenant] = useState(false);
const [legalClauseSignedLandlord, setLegalClauseSignedLandlord] = useState(false);
 const tenantName = 'Ashley Dotson';
  const landlordName = 'Anthony Redmond';
  const leaseAddress = '750 Hilton St Memphis, TN 38114';
  const leaseStartDate = '12/01/2024';
  const leaseEndDate = '11/30/2025';
  const leaseTermMonths = '12';
  const leaseAmount = '$1850.00';
  const moveInFee = '$500.00';
  const adults = '1';
  const children = '2';
  const email = 'ashley@example.com';
  const phone = '(901) 555-1234';
  const appliances = 'Refrigerator, Stove';
  const rentRate = '$1850.00';
  const securityDeposit = '$1850.00';
  const leaseRateOnRenewal = '$1900.00';
  const leaseOccupancyDate = '12/01/2024';
  const currentDate = new Date().toLocaleDateString();
   const leaseRef = useRef(null);
const allSigned = landlordSignedBottom && tenantSigned;

const saveLeaseToFirebase = async () => {
  const leaseNode = leaseRef.current;
  if (!leaseNode) return;

  const canvas = await html2canvas(leaseNode, { scale: 2 });
  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF('p', 'pt', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  const imgProps = pdf.getImageProperties(imgData);
  const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
  heightLeft -= pdfHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
    heightLeft -= pdfHeight;
  }

  const pdfBlob = pdf.output('blob');

  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) {
    alert('Not logged in');
    return;
  }

  const storage = getStorage();
  const leasePath = `signed-leases/${user.uid}/lease.pdf`;
  const storageRef = ref(storage, leasePath);

  await uploadBytes(storageRef, pdfBlob);
  const url = await getDownloadURL(storageRef);

  // Save doc info to Firestore
  const docRef = collection(db, 'documents');
await addDoc(collection(db, 'documents'), {
  name: 'Signed Lease Agreement',
  category: 'Lease',
  status: 'Complete',
  updated: new Date(),
  size: `${Math.round(pdfBlob.size / 1024)} KB`,
  url: url,
  uid: user.uid,
});

  return url;
};

const handleSubmit = async () => {
  if (!tenantSigned  || !section8Signed || !legalClauseSignedTenant || !legalClauseSignedLandlord || !initial1 || !initial2 || !initial3) {
    alert('All signatures and initials must be completed.');
    return;
  }

  setLoading(true); // Start loading

  try {
    await saveLeaseToFirebase();
    setSigned(true);
    if (typeof onClose === 'function') onClose();
  } catch (error) {
    console.error('Error submitting lease:', error);
    alert('Something went wrong saving the lease. Please try again.');
  } finally {
    setLoading(false); // Stop loading
  }
};
  return (

// and in your return:
<Box ref={leaseRef} sx={{ p: 4 }}>
      <Typography variant="h6" gutterBottom>
        Memphis Passive LLC
      </Typography>
      <Typography>
        8016 US Highway 70 Bartlett TN 38133
        <br />
        (901) 410 1310
      </Typography>

      <Typography variant="h6" sx={{ mt: 4 }}>
        Residential Lease Agreement
      </Typography>

      <Typography sx={{ mt: 2 }}>
        Lessor (Landlord), Lessee/Lessees (Tenant/Tenants) hereby on agree as follows:
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>1. LEASE OF PREMISES:</strong> Lessor leases to and Lessee hires from Lessor the Residential dwelling located at 
        <b> {leaseAddress}</b>  hereinafter referred to as the 'Leased Premises' for a term of <b> {leaseTermMonths}</b> months,
        beginning on <b> {leaseStartDate}</b> continuing until <b> {leaseEndDate}</b>, at which time this Residential Lease Agreement shall terminate.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>2. AMOUNT:</strong> Payment for the period from <b> {leaseEndDate}</b> and <b> {leaseStartDate}</b> is to be paid on the First of the month.
        <br />
        Payments of <b>{leaseAmount}</b> per month for the next <b>{leaseTermMonths}</b> months. Lease is a <b>{leaseTermMonths}</b>-month contract, and the total amount of rent <b>${1850 * 12}</b> is to be paid
        in monthly installments of <b>{leaseAmount}</b>, for the first <b>{leaseTermMonths}</b> months.
        <br />
        Rent is to be paid by electronic funds transfer in our online payment platform or in selected stores, and due on or before the 1st day of the month
        before which the Lease Payment is due late after the closing of business on the 5th of each month. Contact (901) 410-1310 for payment: or as otherwise
        specified by Lessor in writing. Payment is only accepted electronically through the online resident portal or through selected stores with your
        personal code.
        <br />
        No other form of payment is accepted. Lessee specifically waives notice of default for nonpayment of rent or any other monetary obligation which is
        due from Lessee to Lessor under the terms of the lease. Payments shall be at the rate of $<b>{leaseAmount}</b> per month for the first <b>{leaseTermMonths}</b> months. The rent charge
        may increase each year up to the market rent.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>3. LATE FEES:</strong> If full payment including late fees or payments due from previous months is not fully posted to the account by the 5th
        of the month a late penalty of 10% will be applied to the total rental amount. An additional $35.00 will be charged for any reversal of payment for any reason.
        The foregoing late fees and charges shall not be construed as a waiver by the Lessor of its right to declare a default under this Agreement.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>4. Security Deposit/Move In Fee:</strong> <b>{moveInFee}</b>. Move-ins are paid prior to occupying the property. $500 is the “move-in fee”, and is assumed
        non-refundable once received by the Lessor. Upon vacating the lessee is responsible for the following, and shall be charged for:
      </Typography>

      <Typography sx={{ mt: 2, pl: 2 }}>
        A. Any lease payment or portion thereof required by the terms of this lease is to be paid in full.<br />
        B. Any unpaid charges and insufficient charges as discussed above or later in this agreement.<br />
        C. Any costs incurred by the Lessor caused by the enforcement of, or Lessee's breach of any terms or provision of this lease - including court costs and attorneys fees.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        Landlord reserves the right and the Tenant agrees that if at any time there is unpaid rent, administrative fees, late fees, maintenance fees or legal fees and/or
        damages to the property and Tenant does not pay the balance within the first 14 days of the month, that the Tenant gives the Landlord the right to remove money
        from the deposit account and apply to any unpaid amount on their rental account. The Landlord's damages shall in no way be limited to the security deposit amount.
        Should Landlord apply these funds to any unpaid balance, the Tenant will be sent a written notice detailing the use of these funds.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>5. OCCUPANCY RULES:</strong> Tenant agrees (a) to use said premises for living rooms and as a private residence only, (b) that premises will be occupied by no more than the following named:
        <br />
        Adults: <b>{adults}</b> Children: <b>{children}</b>
        <br />
        Lessee Email address: <b>{email}</b> 
        <br />
        Lessee Contact Number: <b>{phone}</b>
        
        
        
        <br />
        ● It is the responsibility of the Lessee to ensure their contact information including email address and phone number are current in their resident profile. If the Lessor needs to contact the Lessee for any reason and is unable to reach them by phone or email after three attempts, the Lessor has the right to send someone out to the property in an attempt to contact the Lessee. The Lessee will be charged a $50 trip fee for each occurrence.
        <br />
        ● The Landlord does not assume responsibility for the Tenants furnishings wherever they may be kept on the premises, for any cause whatsoever.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>6. INCLUDED as part of the Leased Property (if present):</strong> all attached light fixtures and bulbs including ceiling fans; permanently attached plate glass mirrors; heating, cooling, and plumbing fixtures and equipment; all doors, storm doors, and windows; all window treatments (e.g. shutters, blinds, shades) and hardware; all wall-to-wall carpet; range; all built-in kitchen appliances; all bathroom fixtures and bathroom mirrors; all security system components and controls; awnings; all landscaping and all outdoor lighting; mailbox(es).
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>7. UTILITIES AND ASSOCIATION DUES:</strong> Lessee will be responsible for payment of all utilities, garbage, water and sewer charges, telephone, gas, and other bills incurred during the term of this Lease. There shall be a $25.00 additional charge for all unpaid Sewer bills. There shall be a $50.00 charge for each utility not placed in Lessee's name within 3 days of signing this lease, plus utility or associated fees to be paid by Lessee.
      </Typography>

    <Box sx={{ mt: 2 }}>
  <Typography>
    <strong>8. USE AND OCCUPANCY:</strong> Lessee shall use the premises in such a manner as to comply with all local, county, state, and federal laws, rules, ordinances, regulations, and codes. Lessee shall not use the premises or permit it to be used for any disorderly or unlawful purpose or in any manner determined by the Lessor to be offensive to any of the neighbors. The premises are to be used exclusively as a residence only by the persons named above and their immediate family. NO OTHER PERSONS MAY LIVE THERE WITHOUT THE LESSOR'S WRITTEN PERMISSION. Guests may stay no longer than two weeks. Lessee may not remove or install any carpet, walls, fencing, or flooring without the written permission of the Lessor. Memphis Passive, LLC reserves the right to perform a visual inspection of the property every 30 days to ensure smoke detectors are operational. Tenants, by signing this lease, agree to this monthly inspection. The tenant agrees to perform lawn maintenance for this property.
  </Typography>

  <Box sx={{ display: 'flex', gap: 4, mt: 1 }}>
    <Box>
      {section8Signed ? (
        <Typography sx={{ fontFamily: 'cursive', fontSize: '20px' }}>{tenantName}</Typography>
      ) : (
        <Button variant="outlined" onClick={() => setSection8Signed(true)}>Sign Section 8</Button>
      )}
      <Typography variant="body2" sx={{ mt: 0.5 }}>Tenant Signature</Typography>
    </Box>

    <Box>
      {landlordSignedSection8 ? (
        <Typography sx={{ fontFamily: 'cursive', fontSize: '20px' }}>{landlordName}</Typography>
      ) : (
        <Button variant="outlined" onClick={() => setLandlordSignedSection8(true)}>Landlord Sign</Button>
      )}
      <Typography variant="body2" sx={{ mt: 0.5 }}>Landlord Signature</Typography>
    </Box>
  </Box>
</Box>

      <Typography sx={{ mt: 2 }}>
        <strong>9. PETS:</strong> WRITTEN CONSENT IS REQUIRED. If there is any pet damage on the property, it shall be the responsibility of the lessee to make any repairs needed (eg: carpet cleaning, yard cleaning, and seeded). If repairs are not done upon move-out, the Lessee understands and agrees that the appropriate amount shall be charged to make those repairs. The granting of consent for pets to others shall in no way be deemed the granting of consent to Lessee. If Lessee wants a pet, Lessee MUST have Lessor's WRITTEN CONSENT and pay an additional $250 and an additional monthly charge of $100 per pet per month. Failure to receive written consent for a pet shall be cause for default.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>10. APPLIANCES:</strong> Appliances, include, but are not limited to none. These appliances are NOT warranted and if they break is the tenant's responsibility. If they are furnished, they shall not be warranted. Maintenance of these units is Lessee's responsibility, and Lessee will keep them in good repair. The following appliances have been supplied by the courtesy of the Lessor: <b>{appliances}</b>. They may not be removed. Portable space heaters are prohibited.
      </Typography>
      <Typography sx={{ mt: 2 }}>
        <strong>11. MAINTENANCE:</strong> During your residency, this property will be in your care and should be treated with respect.
        Lessee will be responsible for hiring QUALIFIED service people to take care of all minor maintenance under
        $200 regardless of cause, and to repair any damage caused by Lessee or Lessee's guests or invitees regardless of
        cost. Evidence of poor quality maintenance or use of unqualified service people is a violation of this Lease. Lessee
        agrees to notify Lessor of any repairs necessary immediately. Any other repairs will be addressed by the Lessor or his
        agent within seventy-two (72) hours, and necessary repairs will be made or initiated within ten (10) days of receiving
        written notice from the Lessee. Lessee will also water and maintain the yard and landscaping at the Leased Premises
        and keep the yard, parking areas, and garbage areas clean and uncluttered. The Landlord will not honor any charges
        or deductions from rent not specifically authorized in advance in writing by property management. If the Board of
        Health/Code Enforcement/Housing Authority is called by the lessee instead of the lessee doing repairs,
        or for fraudulent claims it shall be deemed a default under this lease and subject to IMMEDIATE
        EVICTION.
      </Typography>
      <Typography sx={{ mt: 2, pl: 2 }}>
        ● MAINTENANCE FEES<br />
        ○ TENANT shall pay (a) $150.00 (minimum) for unstopping commodes, and $350.00 (minimum) for
        the main sewer line. (b) for expenses, damages, or repair caused by the stopping of waste pipes or
        overflow from bathtubs, commodes, washbasins, or sinks and (c) for damage to window panes,
        window shades, curtain rods, wallpaper, or any other damage to the interior of the leased premises
        and TENANT shall commit and suffer no waste to be committed therein and no change or alterations
        of the premises shall be made or partitions erected nor walls papered nor any decorating or painting
        without the consent in writing of the LANDLORD first had and obtained.<br />
        ○ LANDLORD shall not be liable for damage caused by failure to keep the premises in repair DUE
        TO UNREPORTED MAINTENANCE OR NEGLIGENCE (which is the responsibility of the
        Tenant to report by submitting a ticket through the resident portal), and shall not be liable for any
        damages done or caused by or from plumbing, gas, water, steam, or other pipes or sewage, or
        freezing/busting, leaking, or running of any pipe, tank washstand, water closet or waste pipe, in,
        above, upon or about said building or premises, the roof, skylight, trap door, carports or otherwise,
        nor for any damage arising from the acts or neglects of co-tenants, or other occupants of the same
        building, or any owners or occupants of adjacent or contiguous property.
        ○ If the premises shall be wrecked or destroyed by fire or by the elements or other causes so as to
        render them unfit for occupancy, or if the furnishings, if any, of LANDLORD property be so
        damaged or destroyed as to be rendered unfit for use and habitation, this lease may thereupon be
        terminated, at the option of LANDLORD: but should the LANDLORD elect to repair or reconstruct
        said premises, and replace or repair said furnishings, he shall do so as speedily as possible and should
        the damage be so extensive as to render the premises untenable, then the rent or a just and
        proportionate part thereof, according to the nature and extent of the damage shall cease until the
        same shall be repaired by LANDLORD but TENANT shall in no case be entitled to compensation
        or damage on account of annoyance or inconvenience in making said repairs, or on account of such
        destruction. The landlord is not responsible for or obligated to find an alternate residence for the
        tenant.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>12. PEST CONTROL:</strong> The lessee is responsible for keeping the premises free of all pests. The Tenant assumes
        the responsibility of keeping the premises free of infestation by roaches, rats, mice, water bugs, bed bugs, rodents,
        moths, termites, or other insect life and assumes the risk of all damages there-from, and neither the Landlord nor the
        Landlord's agent shall be liable nor responsible for damages or injury to the furnishings, wearing apparel or personal
        belongings of the Tenant or other occupants of this property from such sources. If the Board of Health/Code
        Enforcement/Housing Authority is called by the lessee instead of the lessee riding the premises of
        pests, or for fraudulent claims it shall be deemed a default under this lease and subject to
        IMMEDIATE EVICTION.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>13. ALTERATIONS:</strong> Lessee will not paint or alter the Leased Premises in any way, nor change locks without
        obtaining Lessor's prior written approval.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>14. CONDITION:</strong> This residence is rented in "AS-IS" condition, with the understanding that no additional
        improvements will be made at the time of the move-in. Unless Lessee provides written notice within 72 hours of
        moving in, everything in or about the Lease Premises will be considered to be in good working condition. Lessee
        acknowledges there is a smoke detector, carbon monoxide detector (if property has gas elements), and fire extinguisher.
        Lessee agrees to periodically test and maintain the smoke detectors and keep them in working order. The breach,
        default, failure, or violation of any one or more thereof shall, without limitation of their rights, entitle the
        Landlord to terminate this lease immediately, re-enter, and take over the possession of the property.
      </Typography>

<Box sx={{ mt: 4 }}>
  <Typography>
    A. B. C. AT THE DISCRETION OF THE LANDLORD, IF THE TENANT ACCOUNT REQUIRES THE USE OF
    AN ATTORNEY TO PROCURE COLLECTIONS PRIOR TO FILING A FORCIBLE ENTRY AND
    DETAINER THERE WILL BE A MINIMUM LEGAL FEE OF $250.00 THAT MUST BE PAID BY THE
    15TH OF THE MONTH. THIS LEGAL FEE CAN POTENTIALLY BE CHARGED TO YOUR ACCOUNT
    ANY MONTH THAT YOU ARE IN DEFAULT WITHOUT PRIOR AUTHORIZATION OR
    COMMUNICATION WITH MANAGEMENT.
  </Typography>

  <Box sx={{ mt: 1 }}>
    {initial1 ? (
      <Typography sx={{ fontFamily: 'cursive', fontSize: '18px' }}>{tenantName
    .split(' ')
    .map((n) => n.charAt(0).toUpperCase())
    .join('.')}</Typography>
    ) : (
      <Button size="small" variant="outlined" onClick={() => setInitial1(true)}>Initial Here</Button>
    )}
  </Box>

  <Typography sx={{ mt: 2 }}>
    IN ORDER TO STAY IN THE LEASE AND RESIDE ON THE PROPERTY, BILLS SENT TO THE
    TENANT FOR LEGAL-RELATED FEES MUST BE PAID WITHIN 30 DAYS OF BILLING UNLESS
    LANDLORD AND TENANT AGREE UPON OTHER SPECIFIC TERMS
  </Typography>

  <Box sx={{ mt: 1 }}>
    {initial2 ? (
      <Typography sx={{ fontFamily: 'cursive', fontSize: '18px' }}>{tenantName
    .split(' ')
    .map((n) => n.charAt(0).toUpperCase())
    .join('.')}</Typography>
    ) : (
      <Button size="small" variant="outlined" onClick={() => setInitial2(true)}>Initial Here</Button>
    )}
  </Box>

  <Typography sx={{ mt: 2 }}>
    LANDLORD IS NOT RESPONSIBLE FOR PAYMENTS THAT BECOME LOST IN THE MAIL. ANY
    PAYMENTS THAT BECOME LOST IN THE MAIL ARE SUBJECT TO ALL APPLICABLE FEES.
  </Typography>

  <Box sx={{ mt: 1 }}>
    {initial3 ? (
      <Typography sx={{ fontFamily: 'cursive', fontSize: '18px' }}>{tenantName
    .split(' ')
    .map((n) => n.charAt(0).toUpperCase())
    .join('.')}</Typography>
    ) : (
      <Button size="small" variant="outlined" onClick={() => setInitial3(true)}>Initial Here</Button>
    )}
  </Box>

  <Box sx={{ mt: 3, display: 'flex', gap: 4 }}>
    <Box>
      {legalClauseSignedTenant ? (
        <Typography sx={{ fontFamily: 'cursive', fontSize: '20px' }}>{tenantName}</Typography>
      ) : (
        <Button variant="outlined" onClick={() => setLegalClauseSignedTenant(true)}>Sign as Tenant</Button>
      )}
      <Typography variant="body2" sx={{ mt: 0.5 }}>Tenant Signature</Typography>
    </Box>

    <Box>
      {legalClauseSignedLandlord ? (
        <Typography sx={{ fontFamily: 'cursive', fontSize: '20px' }}>{landlordName}</Typography>
      ) : (
        <Button variant="outlined" onClick={() => setLegalClauseSignedLandlord(true)}>Sign as Landlord</Button>
      )}
      <Typography variant="body2" sx={{ mt: 0.5 }}>Landlord Signature</Typography>
    </Box>
  </Box>
</Box>

      <Typography sx={{ mt: 2 }}>
        <strong>15. QUIET ENJOYMENT:</strong> Lessee shall be entitled to the quiet enjoyment of the Leased Premises during the term
        of this Agreement. Resident(s) shall be responsible, at all times, for the conduct of Lessee's guests, licensees, and
        invitees while they are on the premises. If Lessor receives any reasonable complaints concerning the conduct, noise,
        or disturbance of the peace of Lessee or Lessee's guests, licensees, or invitees, such complaint shall constitute a default
        under this Lease Agreement.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>16. VEHICLES:</strong> Lessee may only park functional vehicles with dated tags in assigned spaces where parking space
        is limited. Lessee may not repair Lessee's vehicles on the premises, unless in an enclosed garage if such repairs take
        longer than one day. NO VEHICLES ARE PARKED IN THE YARD. NO BOATS, JET SKIS, TRAILERS, ETC.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>17. SURRENDER AND HOLDOVER:</strong> Upon the expiration of the Lease, Lessee shall surrender the Leased Premises
        to the Owner, along with all property affixed to the Leased Premises. The surrendered Leased Premises must be
        returned in the same clean and sanitary condition as when possession was initially given. This includes, but is not
        limited to, cleaning all floors, carpets, walls, appliances, windows, fixtures, and bathrooms. A professional cleaning
        may be required to restore the unit to its original move-in condition.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        Prior to the expiration of the lease term, Lessee shall remove all personal belongings, trash, and debris, and repair any
        damages beyond normal wear and tear, unless an event of default as hereinafter defined has occurred and remains
        uncured. Any damage caused by the removal of personal property must be repaired by the Lessee before the expiration
        of the lease term. If Lessee fails to remove personal property, it will be deemed abandoned and, at the Lessor's option,
        shall become the property of the Lessor.
        Lessee must provide a minimum 90-day written notice of non-renewal via email to support@memphispassive.com,
        and receipt must be confirmed by Lessor, or Lessor’s staff or associates. Failure to provide such notice within the
        required timeframe will result in an automatic renewal of the lease for an additional one-year term, as per the terms
        set forth below. The lease will renew at a rate of $<b>{leaseAmount}</b> unless a new rate has been established. If the Lessee
        fails to fully vacate the premises per the lease terms or does not sign a new lease at least 15 days prior to the expiration
        of the current lease, the lease will renew automatically.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>18. ASSIGNMENT AND SUBLETTING:</strong> Lessee SHALL NOT assign, mortgage, encumber, or transfer this Lease,
        in whole or in part, or sublet the premises or any part thereof, nor grant a license or concession in connection therewith
        without the prior written consent of the Lessor.
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>19. ENTRY:</strong> Lessee agrees to allow the Lessor to inspect the premises and to show it to prospective Lessees,
        prospective purchasers, mortgagees, and contractors at any reasonable times (8am-6pm). Lessor may display “For
        Rent” or “For Sale” signs on site. With a 24 hours notice, if for any reason the tenant is not able to be present,
        management has the right to enter the property. Notification may be done by phone, text, or email.
        Signature Signature
      </Typography>

      <Typography sx={{ mt: 2 }}>
        <strong>20. ABANDONMENT:</strong> If Lessee abandons or vacates the premises, Lessor may terminate this lease immediately,
        and immediately regain lawful possession. The property shall be considered abandoned when the property has been
        unattended with utilities disconnected for a period of three days or more.
      </Typography>
<Typography sx={{ mt: 2 }}>
  <strong>21. WAIVER:</strong> The waiver of any breach shall not be construed as a continuing waiver of any subsequent breach, and
  the acceptance by Lessor of partial payments due shall not, UNDER ANY CIRCUMSTANCES, constitute a waiver
  of any rights of Lessor under this lease, nor affect any notice of legal proceedings in unlawful detainer, theretofore
  given and commenced under state law.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>22. TERMINATION:</strong> All parties agree that terminating this lease before its termination date is a breach of tenancy
  and all Security deposits plus two full month's rent shall be forfeited to Lessor as liquidated damages, at Lessor's
  option, following termination. Upon termination of this lease, please be advised that the lessor reserves the right to
  remove any personal property left in the leased unit and may dispose of such property immediately and without further
  notice.
</Typography>

<Typography sx={{ mt: 2, pl: 2 }}>
  ● Upon termination of this lease in any manner, Landlord may re-enter the leased premises and remove any
  and all persons and property therefrom, and repossess and enjoy said premises again as of their first and
  former election to terminate this lease, or any demand for the payment of rent or for the possession of the
  leased premises. All remedies of the Landlord under this lease are cumulative and are given without impairing
  any other rights or remedies of the Landlord as provided by law.<br />
  ● If the Tenant shall be in default in the payment of the rent, or under any of the terms of this lease, or if the
  Tenant shall vacate or abandon the premises or any part thereof (as absence of Tenant there-from for a period
  of five days after such default shall be considered such an abandonment thereof), Landlord may, if they so
  elects, without terminating this lease, re-enter said premises and remove all persons and property there-from
  and take possession of said premises and re-let the same, or any part thereof at such rental and upon such
  terms and conditions as he may deem proper, apply the proceeds thereof, less the expenses so incurred, upon
  the amount due from Tenant hereunder, and Tenant shall be liable for any deficiency. If Landlord shall take
  possession of the premises and re-let the same, such re-letting shall not operate as a termination of this lease
  until Landlord so elects; nor shall such action by Landlord operate as a waiver of any other rights or remedies
  of Landlord.<br />
  ● Landlord shall have the right by themself or agent or with others, to enter the premises at reasonable hours
  to examine or exhibit the same, or to make such repairs and alterations as may be deemed necessary by
  Landlord for the safety and preservation of the said building, and within the period of sixty days prior to the
  termination of this lease, to show the flat to prospective tenants.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>23. LIABILITY:</strong> Lessor recommends that Lessee obtain personal liability insurance. Lessor has no insurable interest
  in Lessee's personal property. Nor, will Lessor be liable for any acts by, or damage or injury to Lessee, Lessee's family,
  guests, invitee, or any other persons or property, occurring in or near the premises and Lessee agrees to hold Lessor
  harmless from any claims for damages no matter how caused. Lessee shall be responsible for Rental insurance on his
  personal belongings.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>24. MECHANICS LIENS.</strong> Lessee shall not permit any Statement of Intention to hold a Mechanic's Lien to be filed
  against the Leased Premises or any part thereof nor against any interest or estate therein by reason of labor, services
  or materials claimed to have been performed of, furnished to, or for the Lessee. If such Statement of Intent to hold a
  Mechanic's Lien shall be filed Lessee shall secure the release of said Mechanic's Lien upon notice of said Lien being
  presented to Lessee by Lessor and shall indemnify Lessor for his costs, together with attorney's fees, in securing the
  release of said Lien.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>25. LESSORS’ LIEN.</strong> To secure the payment of rent and other liabilities of Lessee hereunder, Lessee hereby grants
  to Lessor a security interest in all of Lessee's personal property which is now or hereinafter located in the Leased
  Premises and in proceeds thereof, including tort claims and insurance (hereinafter called the "Collateral"). In the event
  of default, Lessor shall have all the remedies of a Secured Party as permitted under Tennessee law.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>26. EVENTS OF DEFAULT.</strong> Any of the following shall be deemed an Event of Default: A. Lessee's failure to pay
  an installment of rent when the same becomes due; B. Lessee's failure to perform or observe any other covenant, term,
  or condition of this lease to be performed or observed by Lessee and if curable, the failure continues for three (3) days
  after notice thereof is given to Lessee; Lessee's abandonment of the Leased Premises; D. The filing or execution or
  occurrence of 1. An involuntary petition of bankruptcy against Lessee and the failure of Lessee, in good faith,
  to promptly commence and diligently pursue action to dismiss the petition; A petition against Lessee seeking
  reorganization, arrangement, composition, readjustment, liquidation, dissolution, or other relief of the same or
  different kind under any provision of the Bankruptcy Act, and the failure of Lessee, in good faith, to promptly
  commence an action to dismiss the petition; 3. A general assignment for the benefit of creditors; 4. The taking by any
  party of the leasehold created hereby or any part thereof, upon foreclosure, levy, execution, attachment, or other
  processes of law or equity. E. Lessee's default under any other agreement between Lessor and Lessee concerning the
  Leased Premises, including any Option to Purchase Agreement between Lessor and Lessee. For purposes of this
  section, the term Lessee shall include any assignee, sublessee, or guarantor of Lessee. This provision shall not be
  construed to permit the assignment of the lease or the subletting of the Leased Premises, except as may be permitted
  hereby. The breach, default, failure, or violation of any one or more thereof shall, without limitation of their
  rights, entitle the Landlord to terminate this lease immediately, re-enter, and take over the possession of the
  property. This also includes up to a $2500 fee that will be added to the Lessee’s ledger in order to re-rent the
  property based on management/owner discretion.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>27. LESSOR'S REMEDIES FOR BREACH.</strong> In the event the Lessee commits an event of default of the Lease, the
  Lessor may, in addition to all other legal or equitable remedies that may be available to the Lessor: A. Continue this
  Agreement by not terminating Lessee's right to possession of the Leased Premises, and continue to enforce all of
  Lessor's rights and remedies under the terms hereof, including the right to recover the rent specified herein as it
  becomes due, or; B. Terminate this Agreement and Lessee's right to possession of the Leased Premises immediately,
  and commence an action against Lessee to recover possession of the Leased Premises and for such damage, as may
  be available at law, including unpaid rent through the remainder of the lease term.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>28. ATTORNEYS' FEES.</strong> Lessor shall be entitled to recover costs and reasonable attorneys' fees in any action or
  proceeding to secure any rights under this Agreement to enforce any remedies available hereunder or at the time of
  legal action. Lessor waives the right to 30-day notice. DEMAND AND NOTICE HEREBY EXPRESSLY WAIVED
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>29. GOVERNMENT ASSISTANCE:</strong>
</Typography>

<Typography sx={{ pl: 2 }}>
  29A General Regulations: Tenants enrolled in the Housing Choice Voucher Program (HCVP), also known as Section
  8, acknowledge that the HCVP may not cover their full rental amount. In such cases, tenants are responsible for paying
  the difference each month on or before the due date...
  {/* full text continues here as per your lease document */}
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>30. ASSOCIATED FEES FOR DAMAGES:</strong> The Tenant hereby agrees to pay the following charges to the Landlord
  prior to the work being completed if the subject property is damaged as follows (all charges are subject to an additional
  $95 trip charge):
</Typography>

<Typography sx={{ pl: 2 }}>
  ● Repaint walls and trim $2,500.00 & up<br />
  ● Replace broken windows<br />
  ○ Trip charge $95 plus the cost of the window<br />
  ○ Per window pane $75<br />
  ○ Holes in sheetrock: Trip charge $150 Per hole $50<br />
  ○ Repaint spot $100<br />
  ● Interior doors damaged or re-hung $250 Replace broken door knobs $35 each<br />
  ○ Re-paint $100<br />
  ● Plumbing repairs<br />
  ○ Trip charge $95 + parts<br />
  ○ TENANT shall pay (a) $150.00 (minimum) for unstopping commodes, and $350.00 (minimum) for the main sewer line. (b) for expenses, damages, or repair caused by the stopping of waste pipes or overflow from bathtubs, commodes, washbasins, or sinks<br />
  ● Any other tenant damage $95 for the first hour plus $75 per hour plus parts<br />
  ● Remove non-operable cars or trucks $275 each<br />
  ● Clean up the yard or cut grass over 6" tall $250 minimum<br />
  ● Treatment for mice, rats, roach, bug, bed bugs or other insect infestation is a minimum charge of $650-$2600<br />
  ● Fill/Cover holes or any damage prevention for pests is to a minimum charge of $125 which includes trip fee<br />
  ● Tenant to change filters every month and wash off the exterior air conditioning unit after each time the grass is cut. Failure to do could cost up to $2,500<br />
  ● Remove cars or trucks parked on grass $300 each Tenant must pay all storage fees.<br />
  ● Key and Lock replacement. Tenants need to be let in because of being locked out.<br />
  ○ To have a new key brought out to the tenant: $150<br />
  ○ If we are required to change out locks, a total of four is $250<br />
  ● Replace the battery in the existing smoke detector is $25<br />
  ○ Replace smoke detector with battery $50<br />
  ● Any call to change the dirty filter, reset electrical breakers, GFI, or any other thing Tenant should be able to handle $95<br />
  ● Plunge toilet to try to unstop, Tenant MUST remove all paper and waste before this can be done $95<br />
  ● I,   <b> {tenantName}</b>, agree that no maintenance work will be done at the subject
  property until rent is paid in full with all fees and charges. This includes heating, air, and electrical.
</Typography>

<Typography sx={{ mt: 2 }}>
  All maintenance must be reported within 72 hours of the incident. Failure to do so can result in the Lessee
  paying the full repair cost. The Lessee must place a Maintenance Request online through the resident portal.
  No request is deemed valid unless placed through the resident portal. Images/videos of the concern MUST be
  provided for the creation of the Job order. All maintenance REQUESTS are handled in the order in which it
  was received, EXCEPT for life-threatening concerns. Landlord's office and/or assigned contractors will call
  the tenant to schedule maintenance appointments on our designated maintenance repair days, which are
  Monday through Friday between 9:30 am - 3:00 pm. Once an appointment is confirmed, tenants must make
  sure to secure personal items which include but are not limited to furniture. The Lessor/Company will NOT be
  held responsible for any damages caused by maintenance orders being performed. Lessee MUST call their
  rental insurance for any destroyed belongings. This includes the ones caused by Acts of God.
</Typography>

<Typography sx={{ mt: 2 }}>
  Contractors will call the tenant prior to arrival. The call MUST be answered. A call from the contractor that
  is not answered will be considered an attempt to address maintenance issues. As a result of a missed call, the
  request will be moved to the end of the maintenance request list. An adult over the age of 18 must be present
  on-site at the time of repairs for the duration of the maintenance visit.
</Typography>

<Typography sx={{ mt: 2 }}>
  It is the tenant's responsibility to make sure Landlord's office has their current phone number. The tenant must answer
  the call from the maintenance technician. Once a maintenance call has been scheduled and contact has been made
  between the technician and Tenant, if the Tenant fails to answer the door Tenant will be charged a minimum trip
  charge of $95. THIS TRIP CHARGE MUST BE PAID IN FULL PRIOR TO ADDITIONAL MAINTENANCE
  REPAIR ATTEMPTS WITH NO EXCEPTIONS. An adult over the age of 18 must be present on-site at the
  time of repairs for the duration of the maintenance visit.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>31. INVALID CLAUSES:</strong> Should any provision of this lease be found to be invalid or unenforceable, the remainder
  of the lease shall not be affected thereby and each term and provision herein shall be valid and enforceable to the
  fullest extent permitted by law.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>32. ENTIRE AGREEMENT:</strong> This leasing document and the attached exhibits constitute the entire agreement
  between the parties and may be modified only in writing and signed by all parties. Any agreement or representation
  between the parties hereto respecting the subject matter of this agreement, whether oral or written, which is not
  expressly set forth in this instrument is null, void, and of no legal effect; provided however that Lessor and Lessee
  may have entered into a separate Option Agreement under which Lessee may have been given the option to purchase
  the Lease Premises, in which case the terms of such Option Agreement shall not be affected by this Lease, except to
  the extent indicated in such Option Agreement, and except that a default under such Option Agreement shall constitute
  and be deemed an event of default under this Lease Agreement.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>33. VIOLATION OF TERMS:</strong> Violation of any part of this agreement or nonpayment of rent when due shall be
  cause for eviction under the appropriate sections of the applicable code and the prevailing party shall recover court
  costs and reasonable attorney's fees. Lessee will make certain that rent is received by the Lessor before the 1st of the
  month. A 5-day notice of nonpayment will be served on the Lessee if payment is not received by the 5th of the month,
  regardless of the fault of the Lessee or the U.S. Postal Service. Notwithstanding the foregoing, the lease will be deemed
  materially and incurably breached and terminated if the rent and/or any additional late fee are not paid by the 10th of
  any month for which rent is due. There shall be a $500.00 fee (subject to change without notice) for each Eviction
  filed. Both Lessor and Lessee further agree to waive trial by jury and submit to the decision of the Judge who has
  jurisdiction over this subject matter. In any event, no action will be filed in any court after one year of the cause(s) for
  such action.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>34. Lessee shall receive occupancy of the premises on <b>{leaseOccupancyDate}</b>. All liabilities for the property become effective</strong>
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>35. MISCELLANEOUS</strong>
</Typography>

<Typography sx={{ pl: 2 }}>
  ● LANDLORD may serve any notice, required or desired to be given hereunder, on TENANT personally, or
  by sending the same through the United States mail, postage prepaid, to the address of TENANT specified
  herein.<br />
  ● LANDLORD AND TENANT mutually agree to waive any right of subrogation which they may. have
  against the other for any losses paid to them on policy or policies carried on the property to the extent
  permitted by the terms of such policy or policies.<br />
  ● Tenants shall in no case be entitled to compensation or damage on account of any annoyance or
  inconvenience in making repairs, or on account of other casualties as contained in the above paragraph 8(c).<br />
  ● Tenant is responsible for notifying the owner of any change in the number of people occupying the property,
  and providing us with a current working phone number, email address, and place of employment, if
  applicable, within 24 hours of the change.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>36. RULES AND REGULATIONS</strong>
</Typography>

<Typography sx={{ pl: 2 }}>
  A. Must keep yards cut and keep clean of debris. This includes but is not limited to overgrown vegetation. Must keep
  all vegetation from making contact with the property or overhanging the property. A minimum fee of $250 will be
  charged to clean your yard.<br />
  B. No parking on lawns, must park vehicles only in designated parking areas. Any vehicle parked on lawns will be
  subject to towing at the owner's expense. No auto repair work is to be done on the premises. All vehicles must be
  licensed & tagged in accordance with city & state codes.<br />
  C. Rent must be paid on the 1st of each month. If rent is received after the 5th, a one-time fee equal to 10% of the
  outstanding balance will be added to the ledger.<br />
  D. Payment is only accepted electronically through the online resident portal or through selected stores with
  your personal code. No other form of payment is accepted unless otherwise specified by the Lessor in writing.<br />
  E. Air and Heat filters must be changed every month to keep units running properly. At any given time, a property
  manager may check, and if the air filter is deemed dirty/older than 30 days, the tenant will be charged a $65 fee to
  their ledger each month the air filter is not changed.<br />
  F. Smoke detectors must be in working condition. Batteries must be tested monthly & changed when necessary. Air
  filters must be changed each month at the time you receive the utility bill.<br />
  H. You are responsible for your guests & their behavior. Breaches of the peace or any other law infraction will cause
  the lease to be terminated. Any time the police are called to your home you MUST contact the office by phone call &
  submit a written statement of the incident.<br />
  I. There is a $50.00 fee for additional copies of the lease/ledger at any time for any reason.<br />
  ● Revising the lease by adding another ADULT is subject to a $150 fine (this already includes the $50
  application fee). The additional adult must place an application online for the property and will have to go
  through the background check. Adding MINORS to the lease is free of charge.<br />
  J. No tenant access to on site storage, including but not limited to, garages, sheds, and attics.<br />
  K. Regarding all drains/plumbing: The Lessee must never pour any type of oil that has the potential to solidify or any
  grease down any drain or in any toilet. The Lessee must never flush any paper towels, napkins, feminine products, or
  wipes (including those marketed as “flushable”) in the toilet or other plumbing.<br />
  L. Tenants must participate in weatherization, such as igniting furnaces before October 15th. Contact MLGW
  promptly for complimentary furnace lighting to enhance efficiency and tenant well-being.<br />
  Weatherization includes, but may not be limited to, these measures:<br />
  ● Change thermostat batteries regularly.<br />
  ● Protect external water fixtures by applying water spigot insulation before November 20 to prevent cold
  weather damage, preserving property integrity.<br />
  ● When the outside temperature drops below 32°F:<br />
  ○ Ensure all faucets drip when the temperature is expected to be below freezing<br />
  ○ Leave all cabinet doors open to prevent frozen pipes and potential pipe damage.<br />
  The tenant will be held liable for any damages arising from non-compliance with these procedures.<br />
  M. All units are non-smoking units. No exceptions.<br />
  I hereby agree and consent to the rules and regulations and will be responsible for the same. This includes paying all
  fees noted.<br />
  Signature(s) Date
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>37. ACKNOWLEDGEMENT:</strong> This Lease shall be construed in accordance with the laws of the State of Tennessee.
  IN WITNESS WHEREOF, Lessor and Lessee have executed the Lease Agreement as of the date and year first above
  written.
</Typography>

<Typography sx={{ mt: 2 }}>
  <strong>38. Lessee specifically waives notice of default for non-payment of rent or any other monetary obligation which is
  due from Lessee to Lessor under the terms of this lease.</strong>
</Typography>
 <Typography sx={{ mt: 4 }}>
        I hereby agree and consent to the rules and regulations and will be responsible for the same. This includes paying all fees noted.
      </Typography>

      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          {tenantSigned ? (
            <Typography sx={{ fontFamily: 'cursive', fontSize: '20px' }}>
              {tenantName}
            </Typography>
          ) : (
            <Button variant="contained" onClick={() => setTenantSigned(true)}>
              Tenant Sign
            </Button>
          )}
          <Typography variant="body2" sx={{ mt: 1 }}>Signature(s)</Typography>
        </Box>

        <Box>
          <Typography>{currentDate}</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>Date: <b>{currentDate}</b></Typography>
        </Box>
      </Box>

      <Box sx={{ mt: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          {landlordSignedBottom ? (
            <Typography sx={{ fontFamily: 'cursive', fontSize: '20px' }}>
              {landlordName}
            </Typography>
          ) : (
            <Button variant="contained" onClick={() => setLandlordSignedBottom(true)}>
              Landlord Sign
            </Button>
          )}
          <Typography variant="body2" sx={{ mt: 1 }}>Printed/Signed of Lessor/Landlord/Agent</Typography>
        </Box>

        <Box>
          <Typography>{currentDate}</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>Date: <b>{currentDate}</b></Typography>
        </Box>

      
      
      </Box>
      {loading && (
  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
    <CircularProgress />
  </Box>
)}
           <Button
  variant="contained"
  color="primary"
  sx={{ mt: 6, mx: 'auto', display: 'block' }}
  onClick={handleSubmit}
  disabled={!allSigned}
>
  Submit Lease 
</Button>
    </Box>

    
  );
}
